const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/clientele", {
	title: __("Clientèle et groupe", "wp-apidae"), // Block title.
	description: __("Affiche un bloc sur les types de clientèle et les tailles de groupes.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.group
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		typesClientele: {
			type: "boolean",
			default: true,
		},
		ageMin: {
			type: "boolean",
			default: true,
		},
		ageMax: {
			type: "boolean",
			default: true,
		},
		tailleGroupeMax: {
			type: "boolean",
			default: true,
		},
		nombrePersonnesMinimum: {
			type: "boolean",
			default: true,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		ss_field_tag: {
			type: 'string',
			default: 'h3',
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
						<ToggleControl
								label={ __( 'Type de clientèle' ) }
								checked={ attributes.typesClientele }
								onChange={ () => {
									props.setAttributes({ typesClientele: ! attributes.typesClientele });
								} }
							/>
						<ToggleControl
								label={ __( 'Age minimum' ) }
								checked={ attributes.ageMin }
								onChange={ () => {
									props.setAttributes({ ageMin: ! attributes.ageMin });
								} }
							/>
							<ToggleControl
								label={ __( 'Age maximum' ) }
								checked={ attributes.ageMax }
								onChange={ () => {
									props.setAttributes({ ageMax: ! attributes.ageMax });
								} }
							/>
							<ToggleControl
								label={ __( 'Taille groupe max.' ) }
								checked={ attributes.tailleGroupeMax }
								onChange={ () => {
									props.setAttributes({ tailleGroupeMax: ! attributes.tailleGroupeMax });
								} }
							/>
							<ToggleControl
								label={ __( 'Personnes min.' ) }
								checked={ attributes.nombrePersonnesMinimum }
								onChange={ () => {
									props.setAttributes({ nombrePersonnesMinimum: ! attributes.nombrePersonnesMinimum });
								} }
							/>
						</PanelBody>
						<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						<SelectControl
							label={ __( 'Balise des sous titres' ) }
							value={ attributes.ss_field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									ss_field_tag: newValue,
								});
							}}
						/>
						</PanelBody>
					</InspectorControls>,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/clientele"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
